import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AppContext } from '../../context/app';
import type { Site } from '../../context/types';
import ButtonStyled from '../shared/button/Button';
import Icon from '../shared/icon/Icon';
import { IconType } from '../shared/icon/types';
import Loading from '../shared/loading/Loading';
import styles from './CampusSelectorLandingPage.module.scss';

export const CampusSelectorLandingPage: React.FC = () => {
  const { setSelectedSite, availableSites } = useContext(AppContext);
  const [selectedListItem, setSelectedListItem] = useState<Site | undefined>();
  const { t } = useTranslation('common');

  const confirmCampusSelection = () =>
    selectedListItem && setSelectedSite(selectedListItem);

  return (
    <div className={styles.page}>
      {availableSites ? (
        <div className={styles.content}>
          <div className={styles.topContent}>
            <div className={styles.iconCircle}>
              <Icon icon={IconType.CAMPUS_LOCATIONS} size="full" color="#fff" />
            </div>
            <div className={styles.titles}>
              <h2 className={styles.title}>{t('selectCampus.title')}</h2>
              <p className={styles.subtitle}>{t('selectCampus.subtitle')}</p>
            </div>
            <div className={styles.campusListContainer}>
              <div className={styles.campusList}>
                {availableSites.map((site) => {
                  const siteAddress = `${site.address.street}, ${site.address.city},
                  ${site.address.state}, ${site.address.zipcode}`;
                  return (
                    <div
                      key={site.id}
                      onClick={() => setSelectedListItem(site)}
                      className={`${styles.listItem} ${
                        selectedListItem &&
                        selectedListItem.id === site.id &&
                        styles.selectedListItem
                      }`}
                    >
                      <p className={styles.listItemTitle}>{site.name}</p>
                      <p className={styles.listItemSubTitle}>{siteAddress}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <ButtonStyled
            disabled={!selectedListItem}
            onClick={confirmCampusSelection}
            className={styles.buttonStartExploring}
            uppercase
          >
            {t('selectCampus.buttonStartExploring')}
          </ButtonStyled>
        </div>
      ) : (
        <Loading isLoading={true} />
      )}
    </div>
  );
};
